export const EXPERIENCES = [
  {
    organization: "Wells Fargo",
    logo: "wellsfargo.png",
    duration: "Feb '25 - Present",
    role: "Senior Software Engineer",
    workedIn: "React, SpringBoot, Microservices, Microfrontends",
    highlights: [
      "Rearchitected Instant Payments into Spring Boot microservices + React micro-frontends, boosting engagement 30%.",
      "Created reusable NPM validation framework used by 10+ micro-frontends, cutting duplication 80%.",
      "Built 'Interceptor' GitHub API tool adopted by 40+ teams, improving PR reviews and stability.",
    ],
  },
  {
    organization: "Wells Fargo",
    logo: "wellsfargo.png",
    duration: "Jul '22 - Feb '25",
    role: "Software Engineer",
    workedIn: "React, SpringBoot, Microservices, Microfrontends",
    highlights: [
      "Built ACH payment app with full-stack + automation, migrating all customers from legacy systems.",
      "Developed Python Flask project template with CI/CD, driving 2500+ internal downloads.",
    ],
  },
  {
    organization: "Totallr Technologies",
    logo: "totallr.png",
    duration: "Apr '21 - Jun '21",
    role: "Software Development Intern",
    workedIn: "Angular, Spring Boot, AWS S3",
    highlights: [
      "Built invoicing system with Angular + Spring Boot, reducing billing errors and boosting efficiency.",
      "Developed analytics dashboard with sales insights, improving forecasting and inventory management.",
    ],
  },
];
